import { Slideout, Typography } from "@ann/web-components";
import EmailHistory from "../emailHistory/emailHistory";

const chatHistory = [
    {
        id: 1,
        type: "send",
        time: "9:30 AM · 03/13/24",
        from: "samutest@gm...",
        to: "mikeabot@gma..",
        cc: ["thomas@dealer...", "thomas@dealer..."],
        body: "Hi Sammy, Thanks for the reminder. I am a bit busy next week. Can we schedule something for the following week? Regards, Mike"
    },
    {
        id: 2,
        type: "receive",
        time: "9:30 AM · 03/13/24",
        from: "samutest@gm...",
        to: "mikeabot@gma..",
        cc: ["thomas@dealer...", "thomas@dealer..."],
        body: "Hi Sammy, Thanks for the reminder. I am a bit busy next week. Can we schedule something for the following week? Regards, Mike"
    },
    {
        id: 3,
        type: "send",
        time: "9:30 AM · 03/13/24",
        from: "samutest@gm...",
        to: "mikeabot@gma..",
        cc: ["thomas@dealer...", "thomas@dealer..."],
        body: "Hi Sammy, Thanks for the reminder. I am a bit busy next week. Can we schedule something for the following week? Regards, Mike"
    },
    {
        id: 4,
        type: "receive",
        time: "9:30 AM · 03/13/24",
        from: "samutest@gm...",
        to: "mikeabot@gma..",
        cc: ["thomas@dealer...", "thomas@dealer..."],
        body: "Hi Sammy, Thanks for the reminder. I am a bit busy next week. Can we schedule something for the following week? Regards, Mike"
    },
    {
        id: 5,
        type: "send",
        time: "9:30 AM · 03/13/24",
        from: "samutest@gm...",
        to: "mikeabot@gma..",
        cc: ["thomas@dealer...", "thomas@dealer..."],
        body: "Hi Sammy, Thanks for the reminder. I am a bit busy next week. Can we schedule something for the following week? Regards, Mike"
    }
]


const EmailSlideOut = ({ open, onClose, email }) => {
    const title = email?.title || "Slide Out Email";

    return (
        <Slideout
            open={open}
            onClose={onClose}
        >
            <Slideout.HeaderActions>
                {/* Temporarily disabled for Version 1 
                    <Button
                    type='secondary'
                    icon='openInFull'
                    size='medium'
                    pill={true}
                /> */}
            </Slideout.HeaderActions>
            <Slideout.Header>
                <div>
                    <Typography
                        category="title"
                        size="large"
                        weight="bold"
                        maxCharacters={40}
                        titleOnHover
                    >
                        {title}
                    </Typography>
                </div>
            </Slideout.Header>
            <Slideout.Content>
                <EmailHistory emailHistory={chatHistory} />
            </Slideout.Content>
        </Slideout>
    );
}

export default EmailSlideOut;